export enum TemplateDialogTabType {
  Template,
  Triggers
}
